import {
    Dialog,
    DialogContent,
    DialogActions,
    Typography, useMediaQuery,
    useTheme
} from '@mui/material';
import CustomButton from '../Button/CustomButton';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Yes',
  cancelText = 'Cancel',
  isLoading = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          mx: isMobile ? 2 : 0,
          my: isMobile ? 8 : 0,
        },
      }}
    >
      <DialogContent
        sx={{
          textAlign: 'center',
          pt: 4,
          pb: 3,
          px: 3,
        }}
      >
        <Typography
          variant="h2"
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          sx={{marginTop: "16px"}}
        >
          {message}
        </Typography>
      </DialogContent>
      
      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 1,
          gap: 2,
          justifyContent: 'center',
        }}
      >
        <CustomButton
          variant="text"
          color="secondary"
          label={cancelText}
          onClick={onClose}
          disabled={isLoading}
          sx={{
            flex: 1,
            height: '44px',
            borderColor: '#995A00',
            color: '#995A00',
            fontSize: '14px',
            fontWeight: 500,
            textTransform: 'none',
            '&:hover': {
              borderColor: '#7a4600',
              backgroundColor: 'rgba(153, 90, 0, 0.04)',
            },
          }}
        />
        <CustomButton
          variant="filled"
          color="warning"
          label={isLoading ? 'Processing...' : confirmText}
          onClick={onConfirm}
          disabled={isLoading}
          sx={{
            flex: 1,
            height: '44px',
            backgroundColor: '#995A00',
            fontSize: '14px',
            fontWeight: 500,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#7a4600',
            },
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
